export default {
  labels: {
    free_items: 'Articoli gratuiti',
    bogo: 'Acquista uno, ottieni uno gratis',
    order_again: 'Ordina di nuovo',
  },
};
